import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Transition as _Transition, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = {
  class: "font-weight-bold",
  style: {"word-break":"break-word","white-space":"normal"}
}

import { onMounted, ref, watch } from 'vue'
import { useTheme } from 'vuetify'
import { useRouter } from 'vue-router'
import { auth, firestore as db } from './main'
import { onAuthStateChanged, signInWithEmailAndPassword } from 'firebase/auth'
import { doc, DocumentSnapshot, getDoc } from 'firebase/firestore'
import { useAuthStore } from './stores/AuthStateStore'
import { storeToRefs } from 'pinia'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const theme = useTheme()
const router = useRouter()
const { setAuthState, setAdminState } = useAuthStore()
const { isSignedIn, isAdmin } = storeToRefs(useAuthStore())

const showMenu = ref(false)
const showSignIn = ref(false)
const showUserInfo = ref(false)
const showProgress = ref(false)
const onVideo = ref(true)

const footerEmail = ref('')
const footerAddress = ref('')

const menuItems = ref([
  {
    href: 'awards',
    title: 'Awards',
    icon: 'fa-trophy'
  },
  {
    href: 'members',
    title: 'Members',
    icon: 'fa-user'
  },
  {
    href: 'news',
    title: 'News',
    icon: 'fa-newspaper'
  },
  {
    href: 'research',
    title: 'Research',
    icon: 'fa-magnifying-glass'
  },
  {
    href: 'lectures',
    title: 'Lectures',
    icon: 'fa-chalkboard-teacher'
  },
  {
    href: 'publications',
    title: 'Publications',
    icon: 'fa-file'
  },
  {
    href: 'gallery',
    title: 'Gallery',
    icon: 'fa-images'
  },
  {
    href: 'contact',
    title: 'Contact',
    icon: 'fa-phone'
  },
  {
    href: 'downloads',
    title: 'Downloads',
    icon: 'fa-download'
  }
])

const email = ref('')
const password = ref('')

function detectMobile () {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

function switchTheme () {
  theme.toggle()
  localStorage.setItem('theme', theme.current.value.dark ? 'dark' : 'light')
}

function signIn () {
  if (email.value === '' || password.value === '') {
    alert('Please enter both email and password.')
    return
  }

  showProgress.value = true

  signInWithEmailAndPassword(auth, email.value, password.value)
    .then(() => {
      showSignIn.value = false
    })
    .catch((error: Error) => {
      alert(`An error occurred while processing sign in.\nPlease check your E-Mail and password, or try again later.\n(${error.message}`)
    })
    .finally(() => {
      showProgress.value = false
    })
}

function signOut () {
  if (confirm('Are you sure you want to sign out?')) {
    auth.signOut()
      .then(() => {
        setAuthState(false)
        setAdminState(false)
        alert('Signed out successfully.')
        showUserInfo.value = false
      })
      .catch((error: Error) => {
        alert(`An error occurred while processing sign out.\nPlease try again later.\n(${error.message})`)
      })
  }
}

function goToGithub () {
  window.location.href = 'https://github.com/h-ch22'
}

watch(showMenu, (newVal) => {
  if (newVal) {
    showSignIn.value = false
    showUserInfo.value = false
  }
})

watch(showSignIn, (newVal) => {
  if (newVal) {
    showMenu.value = false
    showUserInfo.value = false
  }
})

watch(showUserInfo, (newVal) => {
  if (newVal) {
    showMenu.value = false
    showSignIn.value = false
  }
})

onkeyup = (e: KeyboardEvent) => {
  if (e.key === 'Enter' && showSignIn.value) {
    signIn()
  }
}

onscroll = () => {
  if (router.currentRoute.value.path === '/') {
    onVideo.value = window.scrollY < window.innerHeight
  }
}

onAuthStateChanged(auth, (user) => {
  if (user) {
    setAuthState(true)

    if (!menuItems.value.find(item => item.href === 'settings')) {
      menuItems.value.push({
        href: 'settings',
        title: 'Settings',
        icon: 'fa-gear'
      })
    }

    getDoc(doc(db, 'Users', auth.currentUser!.uid))
      .then((doc: DocumentSnapshot) => {
        if (doc.exists()) {
          const data = doc.data()
          setAdminState(data.isAdmin)
        } else {
          setAdminState(false)
        }
      })
  } else {
    setAuthState(false)
    setAdminState(false)
    menuItems.value = menuItems.value.filter(item => item.href !== 'settings')
  }
})

onMounted(() => {
  if (localStorage.getItem('theme') === 'dark' && !theme.current.value.dark) {
    switchTheme()
  } else if (localStorage.getItem('theme') === 'light' && theme.current.value.dark) {
    switchTheme()
  }

  getDoc(doc(db, 'Contact', 'Introduction'))
    .then((doc: DocumentSnapshot) => {
      if (doc.exists()) {
        const data = doc.data()
        footerEmail.value = data.email
        footerAddress.value = data.address
      }
    })
    .catch((e: Error) => {
      console.log(e.message)
    })
})


return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_items = _resolveComponent("v-toolbar-items")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_footer = _resolveComponent("v-footer")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_app_bar, {
        app: "",
        color: "transparent",
        style: _normalizeStyle({
          backdropFilter: _unref(router).currentRoute.value.path === '/' && onVideo.value ?
          'blur(0px)' :
          'blur(2px)'
        })
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_toolbar_title, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_img, {
                class: "home-btn",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'home' }))),
                src: require(`@/assets/SBL_Traditional_Symbol_Horizontal_English_${(_unref(theme).current.value.dark) ? 'White' : 'Black'}.svg`),
                contain: "",
                width: "300",
                "min-width": "150"
              }, null, 8, ["src"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_toolbar_items, null, {
            default: _withCtx(() => [
              (!_unref(isSignedIn))
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    variant: "plain",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (showSignIn.value = !showSignIn.value))
                  }, {
                    default: _withCtx(() => [
                      (showSignIn.value)
                        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                            key: 0,
                            icon: "fa-solid fa-xmark"
                          }))
                        : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                            key: 1,
                            icon: "fa-solid fa-user"
                          }))
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_v_btn, {
                    key: 1,
                    variant: "plain",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (showUserInfo.value = !showUserInfo.value))
                  }, {
                    default: _withCtx(() => [
                      (showUserInfo.value)
                        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                            key: 0,
                            icon: "fa-solid fa-xmark"
                          }))
                        : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                            key: 1,
                            icon: "fa-solid fa-right-from-bracket"
                          }))
                    ]),
                    _: 1
                  })),
              _createVNode(_component_v_btn, {
                variant: "plain",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (switchTheme()))
              }, {
                default: _withCtx(() => [
                  (_unref(theme).current.value.dark)
                    ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                        key: 0,
                        icon: "fa-solid fa-sun"
                      }))
                    : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                        key: 1,
                        icon: "fa-solid fa-moon"
                      }))
                ]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                variant: "plain",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (showMenu.value = !showMenu.value))
              }, {
                default: _withCtx(() => [
                  (showMenu.value)
                    ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                        key: 0,
                        icon: "fa-solid fa-xmark"
                      }))
                    : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                        key: 1,
                        icon: "fa-solid fa-bars"
                      }))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["style"]),
      _createVNode(_component_v_layout, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_main, null, {
            default: _withCtx(() => [
              _createVNode(_component_router_view),
              _createVNode(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                  (showMenu.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "overlay-menu rounded-xl elevation-14 opacity-90",
                        style: _normalizeStyle({ background: _unref(theme).current.value.colors.background, backdropFilter: 'blur(5px)' })
                      }, [
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItems.value, (item) => {
                              return (_openBlock(), _createBlock(_component_v_col, {
                                key: item.title
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", {
                                    class: "menuBtn",
                                    onClick: ($event: any) => {showMenu.value = false; _ctx.$router.push({ name: item.href })}
                                  }, [
                                    _createVNode(_component_font_awesome_icon, {
                                      icon: ['fa-solid', item.icon]
                                    }, null, 8, ["icon"]),
                                    _createElementVNode("div", null, _toDisplayString(item.title), 1)
                                  ], 8, _hoisted_1)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ], 4))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              (showSignIn.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "signin-menu rounded-xl elevation-14 opacity-90",
                    style: _normalizeStyle({
          background: _unref(theme).current.value.colors.background,
          width: detectMobile() ? '80vw' : '25vw',
          backdropFilter: 'blur(5px)'
        })
                  }, [
                    _createVNode(_component_v_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          class: "sign-in-field",
                          modelValue: email.value,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((email).value = $event)),
                          label: "E-Mail",
                          type: "email",
                          "prepend-icon": "mdi-email",
                          color: "primary",
                          style: _normalizeStyle({ width: detectMobile() ? '70vw' : '22vw' }),
                          clearable: "",
                          "clear-icon": "mdi-close",
                          "onClick:clear": _cache[6] || (_cache[6] = ($event: any) => (email.value = ''))
                        }, null, 8, ["modelValue", "style"]),
                        _createVNode(_component_v_text_field, {
                          class: "sign-in-field",
                          modelValue: password.value,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((password).value = $event)),
                          label: "Password",
                          type: "password",
                          "prepend-icon": "mdi-key",
                          color: "primary",
                          style: _normalizeStyle({ width: detectMobile() ? '70vw' : '22vw' }),
                          clearable: "",
                          "clear-icon": "mdi-close",
                          "onClick:clear": _cache[8] || (_cache[8] = ($event: any) => (password.value = ''))
                        }, null, 8, ["modelValue", "style"]),
                        (!showProgress.value)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 0,
                              variant: "tonal",
                              onClick: signIn
                            }, {
                              default: _withCtx(() => _cache[9] || (_cache[9] = [
                                _createTextVNode("Sign In", -1)
                              ])),
                              _: 1,
                              __: [9]
                            }))
                          : (_openBlock(), _createBlock(_component_v_progress_circular, {
                              key: 1,
                              indeterminate: "",
                              color: "primary"
                            }))
                      ]),
                      _: 1
                    })
                  ], 4))
                : _createCommentVNode("", true),
              (showUserInfo.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "signin-menu rounded-xl elevation-14 opacity-90",
                    style: _normalizeStyle({
          background: _unref(theme).current.value.colors.background,
          backdropFilter: 'blur(5px)',
        })
                  }, [
                    _createVNode(_component_v_col, { class: "ma-4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, {
                          style: _normalizeStyle({ width: detectMobile() ? '70vw' : '22vw' })
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, {
                              icon: "fa-solid fa-user",
                              class: "mr-2"
                            }),
                            _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(auth).currentUser?.email), 1)
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        (_unref(isAdmin))
                          ? (_openBlock(), _createBlock(_component_v_row, {
                              key: 0,
                              class: "mt-4",
                              style: _normalizeStyle({ width: detectMobile() ? '70vw' : '22vw', alignItems: 'center' })
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "fa-solid fa-check",
                                  color: "green",
                                  class: "mr-2"
                                }),
                                _cache[10] || (_cache[10] = _createElementVNode("div", { style: {"color":"green"} }, "Administrator", -1))
                              ]),
                              _: 1,
                              __: [10]
                            }, 8, ["style"]))
                          : _createCommentVNode("", true),
                        (!showProgress.value)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 1,
                              class: "mt-6",
                              variant: "tonal",
                              onClick: signOut
                            }, {
                              default: _withCtx(() => _cache[11] || (_cache[11] = [
                                _createTextVNode("Sign Out", -1)
                              ])),
                              _: 1,
                              __: [11]
                            }))
                          : (_openBlock(), _createBlock(_component_v_progress_circular, {
                              key: 2,
                              class: "mt-4",
                              indeterminate: "",
                              color: "primary"
                            }))
                      ]),
                      _: 1
                    })
                  ], 4))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_footer, { color: "#363636" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_container, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { class: "footer-text" }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, _toDisplayString(footerEmail.value), 1),
                      _createElementVNode("p", null, _toDisplayString(footerAddress.value), 1),
                      _createElementVNode("p", null, _toDisplayString('© 2022-' + new Date().getFullYear() + ' Jeonbuk National University Smart Biophotonics Lab. All rights reserved.'), 1),
                      _createElementVNode("p", null, [
                        _cache[12] || (_cache[12] = _createTextVNode("Developed by ", -1)),
                        _createElementVNode("span", {
                          class: "github_link",
                          onClick: goToGithub
                        }, "Changjin Ha")
                      ]),
                      _cache[13] || (_cache[13] = _createElementVNode("p", {
                        class: "mt-2",
                        style: {"color":"gray"}
                      }, "이 웹사이트에 게시된 이메일 주소가 자동으로 수집되는 것을 거부하며, 이를 위반시 정보통신망법에 의해 처벌됨을 유념하시기 바랍니다.", -1)),
                      _cache[14] || (_cache[14] = _createElementVNode("p", { style: {"color":"gray"} }, "Please note that the email addresses posted on this website are not automatically collected, and violators are subject to punishment under the Information and Communications Network Act.", -1)),
                      _createVNode(_component_v_row, { class: "mt-2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_spacer),
                          _createVNode(_component_v_img, {
                            src: require('@/assets/SBL_Traditional_Symbol_Horizontal_English_Black.svg'),
                            width: "300",
                            "max-width": "300",
                            class: "opacity-50"
                          }, null, 8, ["src"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1,
                    __: [13,14]
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})